module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_7005.3e6a0286.png";